// services/createProducts/createProducts.js
import { get, post, put } from "../../utils/request";

export const postProducts = async (key, miniProduct, fullProduct) => {
  const headerRes = await get(`headers-products?key=${key}`);

  if (!headerRes || headerRes.length === 0) {
    throw new Error("Header không tồn tại hoặc sai key");
  }

  const header = headerRes[0];

  const updatedHeader = {
    ...header,
    products: [...(header.products || []), miniProduct],
  };

  await put(`headers-products/${header.id}`, updatedHeader);

  const fullRes = await post("products", fullProduct);

  return {
    header: updatedHeader,
    full: fullRes,
  };
};
